import { createSelector } from '@reduxjs/toolkit';
import { selectTemplatesState } from 'src/store/selectors';

export const selectFeesState = createSelector(selectTemplatesState, (settingsState) => settingsState.fees);

export const selectReportsState = createSelector(selectTemplatesState, (settingsState) => settingsState.reportsTemplate);

export const selectPortfoliosState = createSelector(selectTemplatesState, (settingsState) => settingsState.portfolios);

export const selectEditState = createSelector(selectTemplatesState, (settingsState) => settingsState.edit);

export const selectReportSettingsState = createSelector(selectTemplatesState, (settingsState) => settingsState.reportSettingsState);
